import Vue from 'vue'
import * as types from '../../mutation'
import api from '@/api/home/home'

const state = {
  appExportUrl:[],
  agreementData:'',
  customExportUrl:[],
}
const mutations = {
  [types.GET_APP_EXPORT_URL](state, res) {
      Vue.set(state, 'appExportUrl', res.versionList);
  },
  [types.GET_APP_AGREEMENT](state, res) {
    Vue.set(state, 'agreementData', res.content);
},
  [types.GET_CUSTOM_EXPORT_URL](state, res) {
    Vue.set(state, 'customExportUrl', res.versionList);
  },

}
const actions = {
  getAppExportUrl( {commit} ,data){  //获取学员守则
      return api.getAppExportUrl(data, (res) =>{
          commit(types.GET_APP_EXPORT_URL,res);
      })
  },
  getAgreement( {commit} ,data){  //获取学员守则
    return api.getAgreement(data, (res) =>{
        commit(types.GET_APP_AGREEMENT,res);
    })
  },       
  getCustomExportUrl( {commit} ,data){  //获取安卓定制版app下载路径
    return api.getCustomExportUrl(data, (res) =>{
        commit(types.GET_CUSTOM_EXPORT_URL,res);
    })
  },       
}
const getters = {
  appExportUrl: state => state.appExportUrl,
  agreementData: state => state.agreementData,
  customExportUrl: state => state.customExportUrl
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/home/home.js